import { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { createResourceLocatorString } from '../../../../../util/routes';
import routeConfiguration from '../../../../../routeConfiguration';

export const useCommentVotes = (comment, onVoteComment, currentUser, postId) => {
  const history = useHistory();
  const location = useLocation();
  const [isVoting, setIsVoting] = useState(false);

  // Get current vote state from comment data
  const voteCount = comment.voteCount || 0;
  const userReaction = comment.reactions?.find(r => r.userId === currentUser?.id?.uuid);
  const userVote = userReaction?.type || null;

  const handleVote = async (action) => {
    // Redirect to login if not authenticated
    if (!currentUser?.id?.uuid) {
      const state = {
        from: `${location.pathname}${location.search}${location.hash}`,
      };
      history.push(createResourceLocatorString('LoginPage', routeConfiguration()), state);
      return;
    }

    // Prevent multiple simultaneous votes
    if (isVoting) return;

    setIsVoting(true);
    
    try {
      // Call Redux action - this will update the state optimistically
      await onVoteComment(comment.id, action, postId);
    } catch (error) {
      console.error('Failed to vote on comment:', error);
    } finally {
      setIsVoting(false);
    }
  };

  return { voteCount, userVote, handleVote, isVoting };
};